module.exports = __webpack_public_path__ + "static/media/portfolio_img2.1240944b.jpg";